/* eslint-disable no-barrel-files/no-barrel-files */
/**
 * @generated
 * This file re-exports types from the Relay-generated artifact
 * This file provides type aliases for the Relay-generated artifact
 * to maintain backward compatibility with existing imports.
 * 
 * All types are generated by Relay compiler from GraphQL operations.
 */

export type {
	GlobalOperationsUserPermissionTypeQuery$data as GlobalOperationsUserPermissionTypeQuery,
	GlobalOperationsUserPermissionTypeQuery$variables as GlobalOperationsUserPermissionTypeQueryVariables,
} from '../__generated__/GlobalOperationsUserPermissionTypeQuery.graphql.ts';

// Nested types extracted from Relay-generated types
import type { GlobalOperationsUserPermissionTypeQuery$data } from '../__generated__/GlobalOperationsUserPermissionTypeQuery.graphql.ts';
export type GlobalOperationsUserPermissionTypeQuery_user_AtlassianUser_confluence_ConfluenceUser = NonNullable<NonNullable<GlobalOperationsUserPermissionTypeQuery$data['user']>['confluence']>;
export type GlobalOperationsUserPermissionTypeQuery_user_AtlassianUser = NonNullable<GlobalOperationsUserPermissionTypeQuery$data['user']>;

// GraphQL enums (preserved from original file)
// ⚠️  DEPRECATION WARNING: Prefer using Relay's generated union string types instead of enums.
// Relay generates more type-safe union types (e.g., "DRAFT" | "PUBLISHED" | "ARCHIVED")
// instead of enums. These enums are kept for backward compatibility only.
export enum SitePermissionType {
  ANONYMOUS = "ANONYMOUS",
  APP = "APP",
  EXTERNAL = "EXTERNAL",
  INTERNAL = "INTERNAL",
  JSD = "JSD",
}

